import actions from './actions';
import authActions from '../auth/actions';

const initState = {
  currentDateSelected: new Date().toLocaleDateString('en-us', {
    month: 'long',
    day: '2-digit',
    year: 'numeric'
  }),
  isPastDate: true,
  accountOfficerData: null,
  accountOfficerLoading: false,
  teamData: null,
  teamDataLoading: false,
  teamError: false,
  pageLoading: false,
  isError: false,
  errorMessage: null,
  loading: false,
  leadManagementListData: null,
  leadManagementListLoading: false,
  listError: false,
  listPagination: null,
  listFilter: null,
  leadManagementCalendarData: null,
  leadManagementCalendarLoading: false,
  calendarError: false,
  calendarFilter: null,
  leadManagementReportData: null,
  leadManagementReportLoading: false,
  reportError: false,
  reportFilter: null,
  allMerchants: null,
  allMerchantLoading: false,
  targetProjectionsData: null,
  targetProjectionsLoading: false,
  targetError: false,
  targetFilter: null,
  requirementIsError: false,
  requirementLoading: false,
  requirementData: null,

  fetchingReversalRequest: false,
  fetchedReversalRequest: null,

  merchantStoryLoading: false,
  merchantStoryLoadMore: false,
  merchantStoryData: null,
  merchantStoryIsError: false,
  merchantStoryPagination: null,
  merchantStoryActive: null,

  checkRequirementStatusIsError: false,
  checkRequirementStatusLoading: false,
  requirementStatusIsApproved: null,

  requirementFileLoading: false,
  requirementFileIsError: false,
  requirementFileData: null,
  requirementFileErrorMessage: null,

  merchantStatusLoading: false,
  merchantStatusData: null,
  merchantStatusIsError: false,

  merchantServicesLoading: false,
  merchantServicesData: null,
  merchantServicesIsError: false,

  installmentBankConfigurationsLoading: false,
  installmentBankConfigurationsData: null,
  installmentBankConfigurationsIsError: false,

  leadMonitoringLoading: false,
  leadMonitoringData: null,
  leadMonitoringIsError: false,
  leadMonitoringFilter: null,
  leadMonitoringPagination: null,

  leadsMgmtLoading: false,
  leadsMgmtData: null,
  leadsMgmtIsError: false,
  activeLeads: null,
  leadsMgmtFilter: null,
  leadLoadMoreLoading: false,
  leadsMgmtPagination: null,

  allUploadedLeadsFileDataLoading: false,
  allUploadedLeadsFileData: null,
  allUploadedLeadsFileDataIsError: false,
  allUploadedLeadsFileDataPagination: false,

  allSuspectedDuplicateLeadsLoading: false,
  allSuspectedDuplicateLeads: null,
  allSuspectedDuplicateLeadsIsError: false,
  allSuspectedDuplicateLeadsPagination: false,
  allSuspectedDuplicateLeadsFilter: null,

  showLeadSuspectedDuplicates: false,

  leadLogsLoading: false,
  leadLogsData: null,
  leadLogsIsError: false,
  leadLogsPagination: null,
  leadLogsLoadMore: false,

  leadsNurturingLoading: false,
  leadsNurturing: null,
  leadsNurturingIsError: false,
  leadsNurturingFilter: null,
  leadsNurturingPagination: null,
  leadsNurturingLoadMore: false,
  activeLeadNurturing: null,

  activeLeadNurturingRequest: null,

  presignedUrlsExemptionFilesLoading: false,
  presignedUrlsExemptionFiles: null,
  presignedUrlsExemptionFilesIsError: false,
  downloadExemptionFilesLoading: false,
  downloadExemptionFilesIsError: false,

  presignedUrlsForLeadFileLoading: false,
  presignedUrlsForLeadFileData: null,
  presignedUrlsForLeadFileIsError: false,
  sendLeadDiscussionLoading: false,
  sendLeadDiscussionIsError: false,
  likedLeadID: null,
  likeLeadLoading: false,
  likeLeadIsError: false,

  merchantStatusCount: null,
  merchantStatusCountLoading: false,
  merchantStatusCountIsError: false,
  merchantStatusCountFilter: null,

  presignedUrlsForLeadChangeStatusFileLoading: false,
  presignedUrlsForLeadChangeStatusFileData: null,
  presignedUrlsForLeadChangeStatusFileIsError: false,
  downloadLeadChangeStatusLoading: false,
  downloadLeadChangeStatusIsError: false,

  presignedUrlsForLeadActivityFileLoading: false,
  presignedUrlsForLeadActivityFileData: null,
  presignedUrlsForLeadActivityFileIsError: false,
  downloadLeadActivityFileLoading: false,
  downloadLeadActivityFileIsError: false,

  leadDiscussionLoading: false,
  leadDiscussionData: null,
  leadDiscussionIsError: false,
  leadDiscussionFilter: null,
  leadDiscussionPagination: null,
  leadDiscussionLoadMore: false,

  leadSanitationLoading: false,
  leadSanitation: null,
  leadSanitationIsError: false,
  leadSanitationFilter: null,
  leadSanitationPagination: null,
  leadSanitationLoadMore: false,
  activeLeadSanitation: null,

  // relations manager / account officer
  relationsManagerSearchFilter: null,
  relationsManagerFilter: null,
  relationsManagerSort: null,
  relationsManagerView: null,

  relationsManagerActivityLoadMore: false,
  relationsManagerActivityIsError: false,
  relationsManagerActivityLoading: false,
  relationsManagerActivityData: null,
  relationsManagerActivityFilter: null,
  // merchant management
  merchantManagementLoading: false,
  merchantManagement: null,
  merchantManagementIsError: false,
  merchantManagementFilter: null,
  merchantManagementPagination: null,
  merchantManagementLoadMore: false,
  activeMerchantManagement: null,
  activeMISData: null,

  presignedUrlsSignedProposalLoading: false,
  presignedUrlsSignedProposal: null,
  presignedUrlsSignedProposalIsError: false,
  downloadSignedProposalLoading: false,
  downloadSignedProposalIsError: false,

  presignedUrlsSignedPSALoading: false,
  presignedUrlsSignedPSA: null,
  presignedUrlsSignedPSAIsError: false,
  downloadSignedPSALoading: false,
  downloadSignedPSAIsError: false,

  presignedUrlsVatExemptionLoading: false,
  presignedUrlsVatExemption: null,
  presignedUrlsVatExemptionIsError: false,
  downloadVatExemptionLoading: false,
  downloadVatExemptionIsError: false,

  presignedUrlsWiredTransactionLoading: false,
  presignedUrlsWiredTransaction: null,
  presignedUrlsWiredTransactionIsError: false,
  downloadWiredTransactionLoading: false,
  downloadWiredTransactionIsError: false,

  templateLeadDataLoading: false,
  templateLeadData: null,
  templateLeadDataIsError: false,
  fieldCounterpart: null,

  downloadLeadTemplateFileLoading: false,
  downloadLeadTemplateFileIsError: false
};

export default function monitoringReducer(state = initState, action) {
  switch (action.type) {
    case actions.RESET_ACCOUNT_OFFICER_REDUX:
      return initState;

    case actions.SELECT_CALENDAR_DATE:
      return {
        ...state,
        currentDateSelected: action.payload
      };

    case actions.IS_PAST_DATE:
      return {
        ...state,
        isPastDate: action.payload
      };

    case actions.CLEAR_MESSAGE:
      return {
        ...state,
        errorMessage: null,
        isError: false,
        listError: false,
        calendarError: false,
        reportError: false,
        targetError: false,
        teamError: false,
        requirementFileErrorMessage: null
      };

    case actions.FETCHING_ACCOUNT_OFFICER_DATA:
      return {
        ...state,
        accountOfficerData: null,
        pageLoading: true,
        accountOfficerLoading: action.loading
      };

    case actions.FETCH_ACCOUNT_OFFICER_DATA_SUCCESS:
      return {
        ...state,
        accountOfficerLoading: action.loading,
        pageLoading: false,
        accountOfficerData: action.result,
        isError: false
      };

    case actions.FETCH_ACCOUNT_OFFICER_DATA_FAILED:
      return {
        ...state,
        accountOfficerLoading: action.loading,
        pageLoading: action.loading,
        accountOfficerData: action.result,
        isError: true
      };

    case actions.FETCHING_MERCHANT_STATUS_COUNT_DATA:
      return {
        ...state,
        merchantStatusCountLoading: true
      };

    case actions.FETCH_MERCHANT_STATUS_COUNT_DATA_SUCCESS:
      return {
        ...state,
        merchantStatusCount: action.result,
        merchantStatusCountLoading: false,
        merchantStatusCountIsError: false,
        merchantStatusCountFilter: action.filter
      };

    case actions.FETCH_MERCHANT_STATUS_COUNT_DATA_FAILED:
      return {
        ...state,
        merchantStatusCount: [],
        merchantStatusCountLoading: false,
        merchantStatusCountIsError: true
      };

    case actions.FETCHING_ACCOUNT_OFFICER_TEAM_DATA:
      return {
        ...state,
        teamData: null,
        pageLoading: true,
        teamDataLoading: action.loading
      };

    case actions.FETCH_ACCOUNT_OFFICER_TEAM_DATA_SUCCESS:
      return {
        ...state,
        teamDataLoading: action.loading,
        pageLoading: false,
        teamData: action.result,
        teamError: false
      };

    case actions.FETCH_ACCOUNT_OFFICER_TEAM_DATA_FAILED:
      return {
        ...state,
        teamDataLoading: action.loading,
        pageLoading: action.loading,
        teamData: action.result,
        teamError: true
      };

    case actions.ADDING_ACCOUNT_OFFICER_DATA:
      return {
        ...state,
        isError: false,
        accountOfficerLoading: true,
        pageLoading: true
      };

    case actions.ADD_ACCOUNT_OFFICER_DATA_SUCCESS:
      return {
        ...state,
        accountOfficerLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_ACCOUNT_OFFICER_DATA_FAILED:
      return {
        ...state,
        accountOfficerLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.ADDING_NEW_ACCOUNT_OFFICER_TEAM_DATA:
      return {
        ...state,
        teamError: false,
        teamDataLoading: true,
        pageLoading: true
      };

    case actions.ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA_SUCCESS:
      return {
        ...state,
        teamDataLoading: action.loading,
        errorMessage: action.message,
        teamError: false,
        pageLoading: false
      };

    case actions.ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA_FAILED:
      return {
        ...state,
        teamDataLoading: action.loading,
        errorMessage: action.message,
        teamError: true,
        pageLoading: false
      };

    case actions.EDITING_ACCOUNT_OFFICER_DATA:
      return {
        ...state,
        isError: false,
        accountOfficerLoading: action.loading,
        pageLoading: true
      };

    case actions.EDIT_ACCOUNT_OFFICER_DATA_SUCCESS:
      return {
        ...state,
        accountOfficerLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case actions.EDIT_ACCOUNT_OFFICER_DATA_FAILED:
      return {
        ...state,
        accountOfficerLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.EDITING_ACCOUNT_OFFICER_TEAM_DATA:
      return {
        ...state,
        teamError: false,
        teamDataLoading: action.loading,
        pageLoading: true
      };

    case actions.EDIT_ACCOUNT_OFFICER_TEAM_DATA_SUCCESS:
      return {
        ...state,
        teamDataLoading: action.loading,
        errorMessage: action.message,
        teamError: false,
        pageLoading: action.loading
      };

    case actions.EDIT_ACCOUNT_OFFICER_TEAM_DATA_FAILED:
      return {
        ...state,
        teamDataLoading: action.loading,
        errorMessage: action.message,
        teamError: true,
        pageLoading: action.loading
      };

    case actions.DELETING_ACCOUNT_OFFICER_DATA:
      return {
        ...state,
        isError: false,
        accountOfficerLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.DELETE_ACCOUNT_OFFICER_DATA_SUCCESS:
      return {
        ...state,
        accountOfficerLoading: action.loading,
        errorMessage: action.message,
        pageLoading: action.loading,
        isError: false
      };

    case actions.DELETE_ACCOUNT_OFFICER_DATA_FAILED:
      return {
        ...state,
        accountOfficerLoading: action.loading,
        errorMessage: action.message,
        pageLoading: action.loading,
        isError: true
      };

    case actions.DELETING_ACCOUNT_OFFICER_ON_TEAM_DATA:
      return {
        ...state,
        teamError: false,
        teamDataLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA_SUCCESS:
      return {
        ...state,
        teamDataLoading: action.loading,
        errorMessage: action.message,
        pageLoading: action.loading,
        teamError: false
      };

    case actions.DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA_FAILED:
      return {
        ...state,
        teamDataLoading: action.loading,
        errorMessage: action.message,
        pageLoading: action.loading,
        teamError: true
      };
    case actions.UPDATING_ACCOUNT_OFFICER_STATUS:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        accountOfficerLoading: action.loading
      };

    case actions.UPDATE_ACCOUNT_OFFICER_STATUS_SUCCESS:
      return {
        ...state,
        accountOfficerLoading: action.loading,
        isError: false,
        errorMessage: action.message,
        pageLoading: action.loading
      };

    case actions.UPDATE_ACCOUNT_OFFICER_STATUS_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        accountOfficerLoading: action.loading,
        errorMessage: action.message,
        isError: true
      };

    case actions.REQUESTING_VAT_EXEMPT_REVERSAL_SALES:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        activeFinanceOperationsLoading: true
      };

    case actions.REQUEST_VAT_EXEMPT_REVERSAL_SALES_SUCCESS:
      return {
        ...state,
        activeFinanceOperationsLoading: true,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.REQUEST_VAT_EXEMPT_REVERSAL_SALES_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        activeFinanceOperationsLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.FETCHING_REVERSAL_REQUEST_BY_ID_SALES:
      return {
        ...state,
        isError: false,
        fetchingReversalRequest: true
      };

    case actions.FETCH_REVERSAL_REQUEST_BY_ID_SALES_SUCCESS:
      return {
        ...state,
        fetchingReversalRequest: false,
        //errorMessage: action.message,
        fetchedReversalRequest: action.result,
        pageLoading: false,
        isError: false
      };

    case actions.FETCH_REVERSAL_REQUEST_BY_ID_SALES_FAILED:
      return {
        ...state,
        //errorMessage: action.message,
        fetchingReversalRequest: action.loading,
        fetchedReversalRequest: null,
        isError: true,
        pageLoading: false
      };

    case actions.FETCHING_LEAD_MANAGEMENT_LIST_DATA:
      return {
        ...state,
        leadManagementListData: null,
        pageLoading: true,
        leadManagementListLoading: action.loading
      };

    case actions.FETCH_LEAD_MANAGEMENT_LIST_DATA_SUCCESS:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        pageLoading: false,
        leadManagementListData: action.result,
        listError: false,
        listFilter: action.filter,
        listPagination: action.pagination
      };

    case actions.FETCH_LEAD_MANAGEMENT_LIST_DATA_FAILED:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        pageLoading: action.loading,
        leadManagementListData: action.result,
        listError: true,
        listFilter: null,
        listPagination: null
      };

    case actions.FETCH_LEAD_MANAGEMENT_LIST_DATA_SUCCESS_BY_MQTT:
      return {
        ...state,
        leadManagementListData: action.result,
        listError: false,
        listFilter: action.filter,
        listPagination: action.pagination
      };

    case actions.FETCH_LEAD_MANAGEMENT_LIST_DATA_FAILED_BY_MQTT:
      return {
        ...state,
        leadManagementListData: action.result,
        listError: true
      };

    case actions.FETCHING_FILTERED_LEAD_MANAGEMENT_LIST_DATA:
      return {
        ...state,
        leadManagementListData: null,
        pageLoading: true,
        leadManagementListLoading: action.loading
      };

    case actions.FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA_SUCCESS:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        pageLoading: false,
        leadManagementListData: action.result,
        listError: false,
        listFilter: action.filter,
        listPagination: action.pagination
      };

    case actions.FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA_FAILED:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        pageLoading: false,
        leadManagementListData: action.result,
        listError: true,
        listFilter: null,
        listPagination: null
      };

    case actions.FETCHING_LEAD_MANAGEMENT_CALENDAR_DATA:
      return {
        ...state,
        leadManagementCalendarData: null,
        pageLoading: true,
        leadManagementCalendarLoading: action.loading
      };

    case actions.FETCH_LEAD_MANAGEMENT_CALENDAR_DATA_SUCCESS:
      return {
        ...state,
        leadManagementCalendarLoading: action.loading,
        pageLoading: false,
        calendarFilter: action.filter,
        leadManagementCalendarData: action.result,
        calendarError: false
      };

    case actions.FETCH_LEAD_MANAGEMENT_CALENDAR_DATA_FAILED:
      return {
        ...state,
        leadManagementCalendarLoading: action.loading,
        pageLoading: action.loading,
        leadManagementCalendarData: action.result,
        calendarError: true,
        calendarFilter: action.filter
      };

    case actions.FETCHING_LEAD_MANAGEMENT_REPORT_DATA:
      return {
        ...state,
        leadManagementReportData: null,
        pageLoading: true,
        leadManagementReportLoading: action.loading
      };

    case actions.FETCH_LEAD_MANAGEMENT_REPORT_DATA_SUCCESS:
      return {
        ...state,
        leadManagementReportLoading: action.loading,
        pageLoading: false,
        leadManagementReportData: action.result,
        reportError: false,
        reportFilter: action.filter
      };

    case actions.FETCH_LEAD_MANAGEMENT_REPORT_DATA_FAILED:
      return {
        ...state,
        leadManagementReportLoading: action.loading,
        pageLoading: action.loading,
        leadManagementReportData: action.result,
        reportError: true,
        reportFilter: action.filter
      };

    case actions.UPDATING_LEAD_MERCHANT_LIST_DATA:
      return {
        ...state,
        listError: false,
        leadManagementListLoading: action.loading,
        pageLoading: true
      };

    case actions.UPDATE_LEAD_MERCHANT_LIST_DATA_SUCCESS:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        errorMessage: action.message,
        listError: false,
        pageLoading: action.loading
      };

    case actions.UPDATE_LEAD_MERCHANT_LIST_DATA_FAILED:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        errorMessage: action.message,
        listError: true,
        pageLoading: action.loading
      };

    case actions.COMPLETING_MERCHANT_DETAILS:
      return {
        ...state,
        listError: false,
        pageLoading: true,
        leadManagementListLoading: action.loading
      };

    case actions.COMPLETE_MERCHANT_DETAILS_SUCCESS:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        listError: false,
        errorMessage: action.message,
        pageLoading: action.loading
      };

    case actions.COMPLETE_MERCHANT_DETAILS_FAILED:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        listError: true,
        errorMessage: action.message,
        pageLoading: action.loading
      };

    case actions.COMPLETING_FARMING_MERCHANT_DETAILS:
      return {
        ...state,
        listError: false,
        pageLoading: true,
        leadManagementListLoading: action.loading
      };

    case actions.COMPLETE_FARMING_MERCHANT_DETAILS_SUCCESS:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        listError: false,
        errorMessage: action.message,
        pageLoading: action.loading
      };

    case actions.COMPLETE_FARMING_MERCHANT_DETAILS_FAILED:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        listError: true,
        errorMessage: action.message,
        pageLoading: action.loading
      };

    case (actions.ADDING_LEADS, actions.ADDING_LEADS_BY_RM):
      return {
        ...state,
        isError: false,
        leadsMgmtLoading: true,
        pageLoading: true
      };

    case (actions.ADD_LEADS_SUCCESS, actions.ADD_LEADS_BY_RM_SUCCESS):
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case (actions.ADD_LEADS_FAILED, actions.ADD_LEADS_BY_RM_FAILED):
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.ADDING_LEADS_FROM_SUSPECTED_DUPLICATES:
      return {
        ...state,
        isError: false,
        leadsMgmtLoading: true,
        pageLoading: true
      };

    case actions.ADD_LEADS_FROM_SUSPECTED_DUPLICATES_SUCCESS:
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_LEADS_FROM_SUSPECTED_DUPLICATES_FAILED:
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.REJECTING_LEADS_FROM_SUSPECTED_DUPLICATES:
      return {
        ...state,
        isError: false,
        leadsMgmtLoading: true,
        pageLoading: true,
        allSuspectedDuplicateLeadsLoading: action.loading
      };

    case actions.REJECT_LEADS_FROM_SUSPECTED_DUPLICATES_SUCCESS:
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false,
        allSuspectedDuplicateLeadsLoading: action.loading
      };

    case actions.REJECT_LEADS_FROM_SUSPECTED_DUPLICATES_FAILED:
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false,
        allSuspectedDuplicateLeadsLoading: action.loading
      };

    case actions.TOGGLE_LEADS_SUSPECTED_DUPLICATES:
      return {
        ...state,
        showLeadSuspectedDuplicates: action.payload
      };

    case actions.FETCHING_ALL_LEADS:
      return {
        ...state,
        leadsMgmtData: null,
        pageLoading: action.loading,
        leadsMgmtLoading: action.loading
      };

    case actions.FETCH_ALL_LEADS_SUCCESS:
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        pageLoading: action.loading,
        leadsMgmtData: action.result,
        leadsMgmtFilter: action.filter,
        leadsMgmtPagination: action.pagination,
        isError: false,
        leadLoadMoreLoading: false,
        activeLeads: null
      };

    case actions.FETCHING_ALL_UPLOADED_LEADS_FILE_DATA:
      return {
        ...state,
        allUploadedLeadsFileData: null,
        // pageLoading: action.loading,
        allUploadedLeadsFileDataLoading: action.loading
      };

    case actions.FETCH_ALL_UPLOADED_LEADS_FILE_DATA_SUCCESS:
      return {
        ...state,
        allUploadedLeadsFileDataLoading: action.loading,
        // pageLoading: action.loading,
        allUploadedLeadsFileData: action.result,
        allUploadedLeadsFileDataIsError: false,
        allUploadedLeadsFileDataPagination: action.pagination
      };

    case actions.FETCH_ALL_UPLOADED_LEADS_FILE_DATA_FAILED:
      return {
        ...state,
        allUploadedLeadsFileDataLoading: action.loading,
        pageLoading: action.loading,
        allUploadedLeadsFileData: action.result,
        allUploadedLeadsFileDataIsError: true,
        allUploadedLeadsFileDataPagination: action.pagination
      };

    case actions.FETCHING_ALL_SUSPECTED_DUPLICATE_LEADS:
      return {
        ...state,
        allSuspectedDuplicateLeads: null,
        pageLoading: action.loading,
        allSuspectedDuplicateLeadsLoading: action.loading
      };

    case actions.FETCH_ALL_SUSPECTED_DUPLICATE_LEADS_SUCCESS:
      return {
        ...state,
        allSuspectedDuplicateLeadsLoading: action.loading,
        pageLoading: action.loading,
        allSuspectedDuplicateLeads: action.result,
        allSuspectedDuplicateLeadsIsError: false,
        allSuspectedDuplicateLeadsPagination: action.pagination,
        allSuspectedDuplicateLeadsFilter: action.filter
      };

    case actions.FETCH_ALL_SUSPECTED_DUPLICATE_LEADS_FAILED:
      return {
        ...state,
        allSuspectedDuplicateLeadsLoading: action.loading,
        pageLoading: action.loading,
        allSuspectedDuplicateLeads: action.result,
        allSuspectedDuplicateLeadsIsError: true,
        allSuspectedDuplicateLeadsPagination: action.pagination
      };

    case actions.LOADING_MORE_LEAD_PROFILES:
      return {
        ...state,
        leadLoadMoreLoading: true
      };

    case actions.RESET_ACTIVE_LEAD_BY_ID:
      return {
        ...state,
        activeLeads: null
      };

    case actions.FETCH_ALL_LEADS_FAILED:
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        pageLoading: action.loading,
        leadsMgmtData: action.result,
        isError: true
      };

    case actions.FETCHING_LEAD_LOGS:
      return {
        ...state,
        leadLogsLoading: action.loading
      };

    case actions.FETCH_LEAD_LOGS_SUCCESS:
      const newLeadLogsData = action?.loadMore ?
        [...(state?.leadLogsData ?? []), ...(action?.result ?? [])]?.sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateB - dateA;
        }) ?? [] : action?.result ?? [];

      return {
        ...state,
        leadLogsLoading: action.loading,
        leadLogsData: newLeadLogsData,
        leadLogsIsError: false,
        leadLogsPagination: action.pagination,
        leadLogsLoadMore: false
      };

    case actions.LOADING_MORE_LEAD_LOGS:
      return {
        ...state,
        leadLogsLoadMore: true
      };

    case actions.FETCH_LEAD_LOGS_FAILED:
      return {
        ...state,
        leadLogsLoading: action.loading,
        leadLogsData: action.result,
        leadLogsIsError: true,
        leadLogsPagination: action.pagination,
        leadLogsLoadMore: false
      };
    case actions.RESET_LEAD_LOGS:
      return {
        ...state,
        leadLogsLoading: false,
        leadLogsData: null,
        leadLogsIsError: false,
        leadLogsPagination: null,
        leadLogsLoadMore: false
      };

    case actions.CHANGING_STATUS_NURTURING:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        leadsMgmtLoading: true
      };

    case actions.CHANGE_STATUS_NURTURING_SUCCESS:
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.CHANGE_STATUS_NURTURING_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        leadsMgmtLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.FETCHING_ALL_LEADS_NURTURING:
      return {
        ...state,
        leadsNurturing: null,
        leadsNurturingLoading: true
      };

    case actions.LOADING_MORE_LEADS_NURTURING:
      return {
        ...state,
        leadsNurturingLoadMore: true
      };

    case actions.FETCH_ALL_LEADS_NURTURING_SUCCESS:
      return {
        ...state,
        leadsNurturingLoading: action.loading,
        leadsNurturing: action.result,
        leadsNurturingIsError: false,
        leadsNurturingFilter: action.filter,
        leadsNurturingPagination: action.pagination,
        leadsNurturingLoadMore: false,
        activeLeadNurturing: null
      };

    case actions.FETCH_ALL_LEADS_NURTURING_FAILED:
      return {
        ...state,
        leadsNurturingLoading: action.loading,
        leadsNurturingIsError: true,
        leadsNurturingLoadMore: false
      };

    case actions.FETCHING_LEAD_NURTURING_BY_ID:
      return {
        ...state,
        activeLeadNurturing: null,
        pageLoading: action.loading
      };

    case actions.FETCH_LEAD_NURTURING_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeLeadNurturing: action.result,
        isError: false
      };

    case actions.FETCH_LEAD_NURTURING_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeLeadNurturing: null,
        isError: true
      };

    case actions.FETCHING_LEAD_NURTURING_REQUEST_BY_ID:
      return {
        ...state,
        activeLeadNurturingRequest: null,
        pageLoading: action.loading
      };

    case actions.FETCH_LEAD_NURTURING_REQUEST_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeLeadNurturingRequest: action.result,
        isError: false
      };

    case actions.FETCH_LEAD_NURTURING_REQUEST_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeLeadNurturingRequest: null,
        isError: true
      };

    case actions.UPDATING_LEAD_NURTURING:
      return {
        ...state,
        pageLoading: true
      };

    case actions.UPDATE_LEAD_NURTURING_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.UPDATE_LEAD_NURTURING_FAILED:
      return {
        ...state,
        pageLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.TRIGGERING_LEAD_NURTURING_EXEMPTION_REQUEST:
      return {
        ...state,
        pageLoading: true
      };

    case actions.TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST_FAILED:
      return {
        ...state,
        pageLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.ADDING_INTEGRATION_FORM_REQUEST:
      return {
        ...state,
        pageLoading: true
      };

    case actions.ADD_INTEGRATION_FORM_REQUEST_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.ADD_INTEGRATION_FORM_REQUEST_FAILED:
      return {
        ...state,
        pageLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.CHANGING_STATUS_SANITATION:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        leadsMgmtLoading: true
      };

    case actions.CHANGE_STATUS_SANITATION_SUCCESS:
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.CHANGE_STATUS_SANITATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        leadsMgmtLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.FETCHING_ALL_LEADS_SANITATION:
      return {
        ...state,
        leadSanitation: null,
        leadSanitationLoading: true
      };

    case actions.LOADING_MORE_LEADS_SANITATION:
      return {
        ...state,
        leadSanitationLoadMore: true
      };

    case actions.FETCH_ALL_LEADS_SANITATION_SUCCESS:
      return {
        ...state,
        leadSanitationLoading: action.loading,
        leadSanitation: action.result,
        leadSanitationIsError: false,
        leadSanitationFilter: action.filter,
        leadSanitationPagination: action.pagination,
        leadSanitationLoadMore: false
      };

    case actions.FETCH_ALL_LEADS_SANITATION_FAILED:
      return {
        ...state,
        leadSanitationLoading: action.loading,
        leadSanitationIsError: true,
        leadSanitationLoadMore: false
      };

    case actions.FETCHING_LEAD_SANITATION_BY_ID:
      return {
        ...state,
        activeLeadSanitation: null,
        pageLoading: action.loading
      };

    case actions.FETCH_LEAD_SANITATION_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeLeadSanitation: action.result,
        isError: false
      };

    case actions.FETCH_LEAD_SANITATION_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeLeadSanitation: null,
        isError: true
      };

    case actions.UPDATING_LEAD_SANITATION:
      return {
        ...state,
        pageLoading: true
      };

    case actions.UPDATE_LEAD_SANITATION_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.UPDATE_LEAD_SANITATION_FAILED:
      return {
        ...state,
        pageLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.STORING_ATTACHED_LEAD_FILES_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsForLeadFileLoading: action.loading
      };

    case actions.STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsForLeadFileLoading: action.loading,
        presignedUrlsForLeadFileData: action.result,
        presignedUrlsForLeadFileIsError: false
      };

    case actions.STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsForLeadFileLoading: action.loading,
        presignedUrlsForLeadFileData: action.result,
        presignedUrlsForLeadFileIsError: true
      };

    case actions.STORING_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsForLeadChangeStatusFileLoading: action.loading
      };

    case actions.STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsForLeadChangeStatusFileLoading: action.loading,
        presignedUrlsForLeadChangeStatusFileData: action.result,
        presignedUrlsForLeadChangeStatusFileIsError: false
      };

    case actions.STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsForLeadChangeStatusFileLoading: action.loading,
        presignedUrlsForLeadChangeStatusFileData: action.result,
        presignedUrlsForLeadChangeStatusFileIsError: true
      };

    case actions.STORING_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsForLeadActivityFileLoading: action.loading
      };

    case actions.STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsForLeadActivityFileLoading: action.loading,
        presignedUrlsForLeadActivityFileData: action.result,
        presignedUrlsForLeadActivityFileIsError: false
      };

    case actions.STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsForLeadActivityFileLoading: action.loading,
        presignedUrlsForLeadActivityFileData: action.result,
        presignedUrlsForLeadActivityFileIsError: true
      };

    case actions.SENDING_LEAD_DISCUSSION_ITEM:
      return {
        ...state,
        sendLeadDiscussionLoading: true
      };

    case actions.SEND_LEAD_DISCUSSION_ITEM_SUCCESS:
      return {
        ...state,
        sendLeadDiscussionLoading: action.loading,
        sendLeadDiscussionIsError: false,
        errorMessage: action.message
      };

    case actions.SEND_LEAD_DISCUSSION_ITEM_FAILED:
      return {
        ...state,
        sendLeadDiscussionLoading: action.loading,
        sendLeadDiscussionIsError: true,
        errorMessage: action.message
      };

    case actions.LIKE_LEAD_DISCUSSION_CURRENT_ID:
      return {
        ...state,
        likedLeadID: action.payload
      };

    case actions.LIKING_LEAD_DISCUSSION_DATA:
      return {
        ...state,
        likeLeadLoading: true
      };

    case actions.LIKE_LEAD_DISCUSSION_DATA_SUCCESS:
      return {
        ...state,
        likeLeadLoading: false,
        likeLeadIsError: false
        // errorMessage: action.message
      };

    case actions.LIKE_LEAD_DISCUSSION_DATA_FAILED:
      return {
        ...state,
        likeLeadLoading: false,
        likeLeadIsError: true
        // errorMessage: action.message
      };

    case actions.FETCHING_LEAD_DISCUSSIONS:
      return {
        ...state,
        leadDiscussionLoading: true
      };

    case actions.LOAD_MORE_LEAD_DISCUSSIONS:
      return {
        ...state,
        leadDiscussionLoadMore: true
      };

    case actions.SET_LEAD_DISCUSSION_VALUE:
      return {
        ...state,
        leadDiscussionData: action.payload
      };

    case actions.FETCH_LEAD_DISCUSSIONS_SUCCESS:
      return {
        ...state,
        leadDiscussionLoading: action.loading,
        leadDiscussionData: action.result,
        leadDiscussionIsError: false,
        leadDiscussionFilter: action.filter,
        leadDiscussionPagination: action.pagination,
        leadDiscussionLoadMore: false
      };

    case actions.FETCH_LEAD_DISCUSSIONS_FAILED:
      return {
        ...state,
        leadDiscussionLoading: action.loading,
        leadDiscussionIsError: true,
        leadDiscussionLoadMore: false
      };

    case actions.DOWNLOADING_LEAD_DISCUSSION_ATTACHMENT:
      return {
        ...state,
        sendLeadDiscussionLoading: true
      };

    case actions.DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT_SUCCESS:
      return {
        ...state,
        sendLeadDiscussionLoading: false,
        sendLeadDiscussionIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT_FAILED:
      return {
        ...state,
        sendLeadDiscussionLoading: false,
        sendLeadDiscussionIsError: true,
        errorMessage: action.message
      };

    case actions.STORING_EXEMPTION_FILES_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsExemptionFilesLoading: action.loading
      };

    case actions.STORE_EXEMPTION_FILES_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsExemptionFilesLoading: action.loading,
        presignedUrlsExemptionFiles: action.result,
        presignedUrlsExemptionFilesIsError: false
      };

    case actions.STORE_EXEMPTION_FILES_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsExemptionFilesLoading: action.loading,
        presignedUrlsExemptionFiles: action.result,
        presignedUrlsExemptionFilesIsError: true
      };

    case actions.MANAGING_EXEMPTION_FILES:
      return {
        ...state,
        isError: false,
        pageLoading: true
        // activeFinanceOperationsLoading: true,
        // financeOperationsLoading: true
      };

    case actions.MANAGE_EXEMPTION_FILES_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        presignedUrlsExemptionFiles: null
        // financeOperationsLoading: false
      };

    case actions.MANAGE_EXEMPTION_FILES_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false,
        presignedUrlsExemptionFiles: null
        // financeOperationsLoading: false
      };

    case actions.DOWNLOADING_LEAD_CHANGE_STATUS_ATTACHMENT:
      return {
        ...state,
        downloadLeadChangeStatusLoading: true
      };

    case actions.DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT_SUCCESS:
      return {
        ...state,
        downloadLeadChangeStatusLoading: false,
        downloadLeadChangeStatusIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT_FAILED:
      return {
        ...state,
        downloadLeadChangeStatusLoading: false,
        downloadLeadChangeStatusIsError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_LEAD_ACTIVITY_ATTACHMENT:
      return {
        ...state,
        downloadLeadActivityFileLoading: true
      };

    case actions.DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT_SUCCESS:
      return {
        ...state,
        downloadLeadActivityFileLoading: false,
        downloadLeadActivityFileIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT_FAILED:
      return {
        ...state,
        downloadLeadActivityFileLoading: false,
        downloadLeadActivityFileIsError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_LEADS_BY_ID:
      return {
        ...state,
        activeLeads: null,
        pageLoading: action.loading
      };

    case actions.FETCH_LEADS_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeLeads: action.result,
        isError: false
      };

    case actions.FETCH_LEADS_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeLeads: null,
        isError: true
      };

    case actions.EDITING_LEADS:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        leadsMgmtLoading: true
      };

    case actions.EDIT_LEADS_SUCCESS:
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.EDIT_LEADS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        leadsMgmtLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.EDITING_LEAD_SANITATION:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        leadsMgmtLoading: true
      };

    case actions.EDIT_LEAD_SANITATION_SUCCESS:
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.EDIT_LEAD_SANITATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        leadsMgmtLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.APPROVING_LEAD_SANITATION:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        leadsMgmtLoading: true
      };

    case actions.APPROVE_LEAD_SANITATION_SUCCESS:
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.APPROVE_LEAD_SANITATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        leadsMgmtLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.REJECTING_LEAD_SANITATION:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        leadsMgmtLoading: true
      };

    case actions.REJECT_LEAD_SANITATION_SUCCESS:
      return {
        ...state,
        leadsMgmtLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.REJECT_LEAD_SANITATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        leadsMgmtLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.ADDING_LEAD_MERCHANT_DATA:
      return {
        ...state,
        isError: false,
        leadManagementListLoading: true,
        pageLoading: true
      };

    case actions.ADD_LEAD_MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_LEAD_MERCHANT_DATA_FAILED:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.ADDING_FARMING_LEAD_MERCHANT_DATA:
      return {
        ...state,
        isError: false,
        leadManagementListLoading: true,
        pageLoading: true
      };

    case actions.ADD_FARMING_LEAD_MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_FARMING_LEAD_MERCHANT_DATA_FAILED:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.FETCHING_ALL_MERCHANT_DATA:
      return {
        ...state,
        allMerchants: null,
        pageLoading: true,
        allMerchantLoading: action.loading
      };

    case actions.FETCH_ALL_MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        allMerchantLoading: action.loading,
        pageLoading: false,
        allMerchants: action.result,
        isError: false
      };

    case actions.FETCH_ALL_MERCHANT_DATA_FAILED:
      return {
        ...state,
        allMerchantLoading: action.loading,
        pageLoading: action.loading,
        allMerchants: action.result,
        isError: true
      };
    case actions.ADDING_APPOINTMENT_DATA:
      return {
        ...state,
        isError: false,
        leadManagementCalendarLoading: true,
        pageLoading: true
      };

    case actions.ADD_APPOINTMENT_DATA_SUCCESS:
      return {
        ...state,
        leadManagementCalendarLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false,
        presignedUrlsForLeadActivityFileData: null
      };

    case actions.ADD_APPOINTMENT_DATA_FAILED:
      return {
        ...state,
        leadManagementCalendarLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false,
        presignedUrlsForLeadActivityFileData: null
      };
    case actions.FETCHING_TARGET_PROJECTIONS_DATA:
      return {
        ...state,
        targetProjectionsData: null,
        pageLoading: true,
        targetProjectionsLoading: action.loading
      };

    case actions.FETCH_TARGET_PROJECTIONS_DATA_SUCCESS:
      return {
        ...state,
        targetProjectionsLoading: action.loading,
        pageLoading: false,
        targetProjectionsData: action.result,
        targetError: false,
        targetFilter: action.filter
      };

    case actions.FETCH_TARGET_PROJECTIONS_DATA_FAILED:
      return {
        ...state,
        targetProjectionsLoading: action.loading,
        pageLoading: action.loading,
        targetProjectionsData: action.result,
        targetError: true
      };

    case actions.FETCHING_TARGET_PROJECTIONS_DATA_BY_TEAM:
      return {
        ...state,
        targetProjectionsData: null,
        targetProjectionsLoading: action.loading,
        pageLoading: true
      };

    case actions.FETCH_TARGET_PROJECTIONS_DATA_SUCCESS_BY_TEAM:
      return {
        ...state,
        pageLoading: false,
        targetProjectionsData: action.result,
        targetProjectionsLoading: action.loading,
        targetError: false,
        targetFilter: action.filter
      };

    case actions.FETCH_TARGET_PROJECTIONS_DATA_FAILED_BY_TEAM:
      return {
        ...state,
        targetProjectionsLoading: action.loading,
        targetProjectionsData: null,
        pageLoading: action.loading,
        targetError: true
      };

    case actions.ADDING_MONTHLY_TARGET_DATA:
      return {
        ...state,
        isError: false,
        targetProjectionsLoading: true,
        pageLoading: true
      };

    case actions.ADD_MONTHLY_TARGET_DATA_SUCCESS:
      return {
        ...state,
        targetProjectionsLoading: action.loading,
        errorMessage: action.message,
        targetError: false,
        pageLoading: false
      };

    case actions.ADD_MONTHLY_TARGET_DATA_FAILED:
      return {
        ...state,
        targetProjectionsLoading: action.loading,
        errorMessage: action.message,
        targetError: true,
        pageLoading: false
      };

    case actions.ADDING_CUSTOMER_VISIT_DATA:
      return {
        ...state,
        targetError: false,
        pageLoading: true,
        targetProjectionsLoading: true
      };

    case actions.ADD_CUSTOMER_VISIT_DATA_SUCCESS:
      return {
        ...state,
        targetProjectionsLoading: action.loading,
        pageLoading: false,
        errorMessage: action.message,
        targetError: false
      };

    case actions.ADD_CUSTOMER_VISIT_DATA_FAILED:
      return {
        ...state,
        targetProjectionsLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        targetError: true
      };

    case actions.EDITING_APPOINTMENT_DATA:
      return {
        ...state,
        calendarError: false,
        leadManagementCalendarLoading: action.loading,
        pageLoading: true
      };

    case actions.EDIT_APPOINTMENT_DATA_SUCCESS:
      return {
        ...state,
        leadManagementCalendarLoading: action.loading,
        errorMessage: action.message,
        pageLoading: action.loading,
        calendarError: false
      };

    case actions.EDIT_APPOINTMENT_DATA_FAILED:
      return {
        ...state,
        leadManagementCalendarLoading: action.loading,
        pageLoading: action.loading,
        errorMessage: action.message,
        calendarError: true
      };

    case actions.UPDATING_MONTHLY_TARGET_DATA:
      return {
        ...state,
        targetError: false,
        pageLoading: true,
        targetProjectionsLoading: action.loading
      };

    case actions.UPDATE_MONTHLY_TARGET_DATA_SUCCESS:
      return {
        ...state,
        targetProjectionsLoading: action.loading,
        targetError: false,
        errorMessage: action.message,
        pageLoading: action.loading
      };

    case actions.UPDATE_MONTHLY_TARGET_DATA_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        targetProjectionsLoading: action.loading,
        errorMessage: action.message,
        targetError: true
      };

    case actions.UPDATING_CUSTOMER_VISIT_DATA:
      return {
        ...state,
        targetError: false,
        targetProjectionsLoading: action.loading,
        pageLoading: true
      };

    case actions.UPDATE_CUSTOMER_VISIT_DATA_SUCCESS:
      return {
        ...state,
        targetError: false,
        errorMessage: action.message,
        targetProjectionsLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.UPDATE_CUSTOMER_VISIT_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: action.loading,
        targetProjectionsLoading: action.loading,
        targetError: true
      };
    case actions.RESET_TARGET_PROJECTIONS_DATA:
      return {
        ...state,
        targetProjectionsData: null
      };

    case actions.PASSING_STATUS_REQUIREMENT_DATA_DATA:
      return {
        ...state,
        listError: false,
        leadManagementListLoading: action.loading,
        pageLoading: true
      };

    case actions.PASS_STATUS_REQUIREMENT_DATA_DATA_SUCCESS:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        errorMessage: action.message,
        pageLoading: action.loading,
        listError: false
      };

    case actions.PASS_STATUS_REQUIREMENT_DATA_DATA_FAILED:
      return {
        ...state,
        leadManagementListLoading: action.loading,
        pageLoading: action.loading,
        errorMessage: action.message,
        listError: true
      };

    case actions.FETCHING_REQUIREMENT_BY_MERCHANT_ID_DATA:
      return {
        ...state,
        requirementData: null,
        pageLoading: true,
        requirementLoading: action.loading
      };

    case actions.FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA_SUCCESS:
      return {
        ...state,
        requirementLoading: action.loading,
        pageLoading: false,
        requirementData: action.result,
        requirementIsError: false
      };

    case actions.FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA_FAILED:
      return {
        ...state,
        requirementLoading: action.loading,
        pageLoading: action.loading,
        requirementData: action.result,
        requirementIsError: true
      };

    case actions.FETCHING_STORY_BY_MERCHANT_ID_DATA:
      return {
        ...state,
        merchantStoryLoading: action.loading
      };

    case actions.FETCH_STORY_BY_MERCHANT_ID_DATA_SUCCESS:
      return {
        ...state,
        merchantStoryLoading: action.loading,
        merchantStoryData: action.result,
        merchantStoryIsError: false,
        merchantStoryPagination: action.pagination,
        merchantStoryLoadMore: false,
        merchantStoryActive: action.payload
      };

    case actions.LOADING_MORE_STORY_BY_MERCHANT_ID_DATA:
      return {
        ...state,
        merchantStoryLoadMore: true
      };

    case actions.FETCH_STORY_BY_MERCHANT_ID_DATA_FAILED:
      return {
        ...state,
        merchantStoryLoading: action.loading,
        merchantStoryIsError: true,
        merchantStoryLoadMore: false,
        merchantStoryData: action.payload
      };
    case actions.RESET_STORY_BY_MERCHANT_ID_DATA:
      return {
        ...state,
        merchantStoryLoadMore: false,
        merchantStoryIsError: false,
        merchantStoryLoading: false,
        merchantStoryData: action.payload,
        merchantStoryActive: null
      };
    case actions.CHECKING_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA:
      return {
        ...state,
        checkRequirementStatusIsError: false,
        checkRequirementStatusLoading: true
      };

    case actions.CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA_SUCCESS:
      return {
        ...state,
        checkRequirementStatusLoading: action.loading,
        checkRequirementStatusIsError: false,
        requirementStatusIsApproved: action.result
      };

    case actions.CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA_FAILED:
      return {
        ...state,
        checkRequirementStatusLoading: action.loading,
        checkRequirementStatusIsError: true,
        requirementStatusIsApproved: null
      };

    case actions.DOWNLOADING_REQUIREMENT_FILE_DATA:
      return {
        ...state,
        requirementFileLoading: true
        // pageLoading: true
      };

    case actions.DOWNLOAD_REQUIREMENT_FILE_DATA_SUCCESS:
      return {
        ...state,
        requirementFileLoading: action.loading,
        requirementFileErrorMessage: action.message,
        requirementFileIsError: false,
        // pageLoading: false,
        requirementFileData: action.payload
      };

    case actions.DOWNLOAD_REQUIREMENT_FILE_DATA_FAILED:
      return {
        ...state,
        requirementFileLoading: action.loading,
        requirementFileErrorMessage: action.message,
        requirementFileIsError: true,
        // pageLoading: false,
        requirementFileData: action.payload
      };

    case actions.REMOVE_REQUIREMENT_FILE_DATA_STORAGE:
      return {
        ...state,
        requirementFileData: null,
        requirementFileIsError: false,
        requirementFileLoading: false
      };

    case actions.FETCHING_MERCHANT_SERVICES:
      return {
        ...state,
        merchantServicesData: null,
        merchantServicesLoading: true
      };

    case actions.FETCH_MERCHANT_SERVICES_SUCCESS:
      return {
        ...state,
        merchantServicesLoading: action.loading,
        merchantServicesData: action.result,
        merchantServicesIsError: false,
        merchantServicesFilter: action.filter
      };

    case actions.FETCH_MERCHANT_SERVICES_FAILED:
      return {
        ...state,
        installmentBankConfigurationsLoading: action.loading,
        installmentBankConfigurationsData: action.result,
        installmentBankConfigurationsIsError: true
      };

    case actions.FETCHING_INSTALLMENT_BANK_CONFIGURATIONS:
      return {
        ...state,
        installmentBankConfigurationsData: null,
        installmentBankConfigurationsLoading: true
      };

    case actions.FETCH_INSTALLMENT_BANK_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        installmentBankConfigurationsLoading: action.loading,
        installmentBankConfigurationsData: action.result,
        installmentBankConfigurationsIsError: false,
        installmentBankConfigurationsFilter: action.filter
      };

    case actions.FETCH_INSTALLMENT_BANK_CONFIGURATIONS_FAILED:
      return {
        ...state,
        installmentBankConfigurationsLoading: action.loading,
        installmentBankConfigurationsData: action.result,
        installmentBankConfigurationsIsError: true
      };

    case actions.FETCHING_MERCHANT_STATUS:
      return {
        ...state,
        merchantStatusData: null,
        merchantStatusLoading: true
      };

    case actions.FETCH_MERCHANT_STATUS_SUCCESS:
      return {
        ...state,
        merchantStatusLoading: action.loading,
        merchantStatusData: action.result,
        merchantStatusIsError: false,
        merchantStatusFilter: action.filter
      };

    case actions.FETCH_MERCHANT_STATUS_FAILED:
      return {
        ...state,
        merchantStatusLoading: action.loading,
        merchantStatusData: action.result,
        merchantStatusIsError: true
      };

    case actions.ADDING_MERCHANT_STATUS:
      return {
        ...state,
        merchantStatusIsError: false,
        merchantStatusLoading: true
      };

    case actions.ADD_MERCHANT_STATUS_SUCCESS:
      return {
        ...state,
        merchantStatusLoading: action.loading,
        errorMessage: action.message,
        merchantStatusIsError: false
      };

    case actions.ADD_MERCHANT_STATUS_FAILED:
      return {
        ...state,
        merchantStatusLoading: action.loading,
        errorMessage: action.message,
        merchantStatusIsError: true
      };

    case actions.EDITING_MERCHANT_STATUS:
      return {
        ...state,
        merchantStatusIsError: false,
        merchantStatusLoading: true
      };

    case actions.EDIT_MERCHANT_STATUS_SUCCESS:
      return {
        ...state,
        merchantStatusLoading: action.loading,
        errorMessage: action.message,
        merchantStatusIsError: false
      };

    case actions.EDIT_MERCHANT_STATUS_FAILED:
      return {
        ...state,
        merchantStatusLoading: action.loading,
        errorMessage: action.message,
        merchantStatusIsError: true
      };

    case actions.EDITING_MERCHANT_STATUS_NOTIFICATION_SETTINGS:
      return {
        ...state,
        merchantStatusIsError: false,
        merchantStatusLoading: true
      };

    case actions.EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS_SUCCESS:
      return {
        ...state,
        merchantStatusLoading: action.loading,
        errorMessage: action.message,
        merchantStatusIsError: false
      };

    case actions.EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS_FAILED:
      return {
        ...state,
        merchantStatusLoading: action.loading,
        errorMessage: action.message,
        merchantStatusIsError: true
      };

    case actions.CHANGING_STATUS_MERCHANT_STATUS:
      return {
        ...state,
        merchantStatusIsError: false,
        merchantStatusLoading: true
      };

    case actions.CHANGE_STATUS_MERCHANT_STATUS_SUCCESS:
      return {
        ...state,
        merchantStatusLoading: action.loading,
        errorMessage: action.message,
        merchantStatusIsError: false
      };

    case actions.CHANGE_STATUS_MERCHANT_STATUS_FAILED:
      return {
        ...state,
        merchantStatusLoading: action.loading,
        errorMessage: action.message,
        merchantStatusIsError: true
      };

    case actions.REORDERING_MERCHANT_STATUS_DATA:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        merchantStatusLoading: true
      };

    case actions.REORDER_MERCHANT_STATUS_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: false,
        merchantStatusLoading: false
      };

    case actions.REORDER_MERCHANT_STATUS_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false,
        merchantStatusLoading: false
      };

    case actions.FETCHING_LEAD_MONITORING:
      return {
        ...state,
        leadMonitoringData: null,
        leadMonitoringLoading: true
      };

    case actions.FETCH_LEAD_MONITORING_SUCCESS:
      return {
        ...state,
        leadMonitoringLoading: action.loading,
        leadMonitoringData: action.result,
        leadMonitoringIsError: false,
        leadMonitoringFilter: action.filter,
        leadMonitoringPagination: action.pagination
      };

    case actions.FETCH_LEAD_MONITORING_FAILED:
      return {
        ...state,
        leadMonitoringLoading: action.loading,
        leadMonitoringData: action.result,
        leadMonitoringIsError: true
      };

    case actions.FILTER_SEARCH_RELATIONS_MANAGER:
      return {
        ...state,
        relationsManagerSearchFilter: action.payload
      };

    case actions.FILTER_RELATIONS_MANAGER:
      return {
        ...state,
        relationsManagerFilter: action.payload
      };

    case actions.CHANGE_RELATIONS_MANAGER_VIEW:
      return {
        ...state,
        relationsManagerView: action.payload
      };

    case actions.FETCHING_RELATIONS_MANAGER_LEAD_LOGS:
      return {
        ...state,
        relationsManagerActivityLoading: action.loading
      };

    case actions.FETCH_RELATIONS_MANAGER_LEAD_LOGS_SUCCESS:
      return {
        ...state,
        relationsManagerActivityLoading: action.loading,
        relationsManagerActivityData: action.result,
        relationsManagerActivityIsError: false,
        relationsManagerActivityPagination: action.pagination,
        relationsManagerActivityLoadMore: false,
        relationsManagerActivityFilter: action.filter
      };

    case actions.LOADING_MORE_RELATIONS_MANAGER_LEAD_LOGS:
      return {
        ...state,
        relationsManagerActivityLoadMore: true
      };

    case actions.FETCH_RELATIONS_MANAGER_LEAD_LOGS_FAILED:
      return {
        ...state,
        relationsManagerActivityLoading: action.loading,
        relationsManagerActivityIsError: true,
        relationsManagerActivityLoadMore: false,
        relationsManagerActivityData: action.payload
      };
    case actions.RESET_RELATIONS_MANAGER_LEAD_LOGS:
      return {
        ...state,
        relationsManagerActivityIsError: false,
        relationsManagerActivityData: null,
        relationsManagerActivityFilter: null
      };
    case actions.FETCHING_ALL_MERCHANT_MANAGEMENT:
      return {
        ...state,
        merchantManagement: null,
        merchantManagementLoading: true
      };

    case actions.LOADING_MORE_MERCHANT_MANAGEMENT:
      return {
        ...state,
        merchantManagementLoadMore: true
      };

    case actions.FETCH_ALL_MERCHANT_MANAGEMENT_SUCCESS:
      return {
        ...state,
        merchantManagementLoading: action.loading,
        merchantManagement: action.result,
        merchantManagementIsError: false,
        merchantManagementFilter: action.filter,
        merchantManagementPagination: action.pagination,
        merchantManagementLoadMore: false,
        activeMerchantManagement: null
      };

    case actions.FETCH_ALL_MERCHANT_MANAGEMENT_FAILED:
      return {
        ...state,
        merchantManagementLoading: action.loading,
        merchantManagementIsError: true,
        merchantManagementLoadMore: false
      };

    case actions.FETCHING_MERCHANT_MANAGEMENT_BY_ID:
      return {
        ...state,
        activeMerchantManagement: null,
        pageLoading: action.loading
      };

    case actions.FETCH_MERCHANT_MANAGEMENT_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeMerchantManagement: action.result,
        isError: false
      };

    case actions.FETCH_MERCHANT_MANAGEMENT_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeMerchantManagement: null,
        isError: true
      };

    case actions.COMPLETING_SALES_REQ_INFO:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        merchantManagementLoading: true
      };

    case actions.COMPLETE_SALES_REQ_INFO_SUCCESS:
      return {
        ...state,
        merchantManagementLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        presignedUrlsSignedPSA: null,
        presignedUrlsSignedProposal: null,
        presignedUrlsVatExemption: null,
        presignedUrlsWiredTransaction: null
      };

    case actions.COMPLETE_SALES_REQ_INFO_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantManagementLoading: action.loading,
        isError: true,
        pageLoading: false,
        presignedUrlsSignedPSA: null,
        presignedUrlsSignedProposal: null,
        presignedUrlsVatExemption: null,
        presignedUrlsWiredTransaction: null
      };

    case (actions.TRIGGERING_INVOICE_CREATION,
    actions.SENDING_MIS_FORM_LINK,
    actions.RESENDING_MIS_LINK):
      return {
        ...state,
        isError: false,
        pageLoading: true,
        merchantManagementLoading: true
      };

    case (actions.TRIGGER_INVOICE_CREATION_SUCCESS,
    actions.SEND_MIS_FORM_LINK_SUCCESS,
    actions.RESEND_MIS_LINK_SUCCESS):
      return {
        ...state,
        merchantManagementLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case (actions.TRIGGER_INVOICE_CREATION_FAILED,
    actions.SEND_MIS_FORM_LINK_FAILED,
    actions.RESEND_MIS_LINK_FAILED):
      return {
        ...state,
        errorMessage: action.message,
        merchantManagementLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.STORING_SIGNED_PROPOSAL_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsSignedProposalLoading: action.loading
      };

    case actions.STORE_SIGNED_PROPOSAL_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsSignedProposalLoading: action.loading,
        presignedUrlsSignedProposal: action.result,
        presignedUrlsSignedProposalIsError: false
      };

    case actions.STORE_SIGNED_PROPOSAL_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsSignedProposalLoading: action.loading,
        presignedUrlsSignedProposal: action.result,
        presignedUrlsSignedProposalIsError: true
      };
    case actions.STORING_SIGNED_PSA_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsSignedPSALoading: action.loading
      };

    case actions.STORE_SIGNED_PSA_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsSignedPSALoading: action.loading,
        presignedUrlsSignedPSA: action.result,
        presignedUrlsSignedPSAIsError: false
      };

    case actions.STORE_SIGNED_PSA_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsSignedPSALoading: action.loading,
        presignedUrlsSignedPSA: action.result,
        presignedUrlsSignedPSAIsError: true
      };

    case actions.DOWNLOADING_NURTURING_EXEMPTION_FILE:
      return {
        ...state,
        downloadNurturingExemptionLoading: true
      };

    case actions.DOWNLOAD_NURTURING_EXEMPTION_FILE_SUCCESS:
      return {
        ...state,
        downloadNurturingExemptionLoading: false,
        downloadNurturingExemptionIsError: false
      };

    case actions.DOWNLOAD_NURTURING_EXEMPTION_FILE_FAILED:
      return {
        ...state,
        downloadNurturingExemptionLoading: false,
        downloadNurturingExemptionIsError: true
      };

    case actions.DOWNLOADING_SIGNED_PROPOSAL_FILE:
      return {
        ...state,
        downloadSignedProposalLoading: true,
        pageLoading: true
      };

    case actions.DOWNLOAD_SIGNED_PROPOSAL_FILE_SUCCESS:
      return {
        ...state,
        downloadSignedProposalLoading: false,
        pageLoading: false,
        downloadSignedProposalIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_SIGNED_PROPOSAL_FILE_FAILED:
      return {
        ...state,
        downloadSignedProposalLoading: false,
        pageLoading: false,
        downloadSignedProposalIsError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_SIGNED_PSA_FILE:
      return {
        ...state,
        downloadSignedPSALoading: true,
        pageLoading: true
      };

    case actions.DOWNLOAD_SIGNED_PSA_FILE_SUCCESS:
      return {
        ...state,
        downloadSignedPSALoading: false,
        pageLoading: false,
        downloadSignedPSAIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_SIGNED_PSA_FILE_FAILED:
      return {
        ...state,
        downloadSignedPSALoading: false,
        pageLoading: false,
        downloadSignedPSAIsError: true,
        errorMessage: action.message
      };

    case actions.STORING_VAT_EXEMPTION_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsVatExemptionLoading: action.loading
      };

    case actions.STORE_VAT_EXEMPTION_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsVatExemptionLoading: action.loading,
        presignedUrlsVatExemption: action.result,
        presignedUrlsVatExemptionIsError: false
      };

    case actions.STORE_VAT_EXEMPTION_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsVatExemptionLoading: action.loading,
        presignedUrlsVatExemption: action.result,
        presignedUrlsVatExemptionIsError: true
      };

    case actions.DOWNLOADING_VAT_EXEMPTION_FILE:
      return {
        ...state,
        downloadVatExemptionLoading: true,
        pageLoading: true
      };

    case actions.DOWNLOAD_VAT_EXEMPTION_FILE_SUCCESS:
      return {
        ...state,
        downloadVatExemptionLoading: false,
        pageLoading: false,
        downloadVatExemptionIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_VAT_EXEMPTION_FILE_FAILED:
      return {
        ...state,
        downloadVatExemptionLoading: false,
        pageLoading: false,
        downloadVatExemptionIsError: true,
        errorMessage: action.message
      };

    case actions.STORING_WIRED_TRANSACTION_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsWiredTransactionLoading: action.loading
      };

    case actions.STORE_WIRED_TRANSACTION_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsWiredTransactionLoading: action.loading,
        presignedUrlsWiredTransaction: action.result,
        presignedUrlsWiredTransactionIsError: false
      };

    case actions.STORE_WIRED_TRANSACTION_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsWiredTransactionLoading: action.loading,
        presignedUrlsWiredTransaction: action.result,
        presignedUrlsWiredTransactionIsError: true
      };

    case actions.DOWNLOADING_WIRED_TRANSACTION_FILE:
      return {
        ...state,
        downloadWiredTransactionLoading: true,
        pageLoading: true
      };

    case actions.DOWNLOAD_WIRED_TRANSACTION_FILE_SUCCESS:
      return {
        ...state,
        downloadWiredTransactionLoading: false,
        pageLoading: false,
        downloadWiredTransactionIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_WIRED_TRANSACTION_FILE_FAILED:
      return {
        ...state,
        downloadWiredTransactionLoading: false,
        pageLoading: false,
        downloadWiredTransactionIsError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_TEMPLATE_LEAD_DATA:
      return {
        ...state,
        templateLeadData: null,
        fieldCounterpart: null,
        pageLoading: action.loading,
        templateLeadDataLoading: action.loading
      };

    case actions.FETCH_TEMPLATE_LEAD_DATA_SUCCESS:
      return {
        ...state,
        templateLeadDataLoading: action.loading,
        pageLoading: action.loading,
        templateLeadData: action.result,
        templateLeadDataIsError: false,
        fieldCounterpart: action.fields
      };

    case actions.FETCH_TEMPLATE_LEAD_DATA_FAILED:
      return {
        ...state,
        templateLeadDataLoading: action.loading,
        pageLoading: action.loading,
        templateLeadData: action.result,
        templateLeadDataIsError: true,
        fieldCounterpart: action.fields
      };

    case actions.ADDING_TEMPLATE_LEAD_DATA:
      return {
        ...state,
        templateLeadDataIsError: false,
        templateLeadDataLoading: true,
        pageLoading: true
      };

    case actions.ADD_TEMPLATE_LEAD_DATA_SUCCESS:
      return {
        ...state,
        templateLeadDataLoading: action.loading,
        errorMessage: action.message,
        templateLeadDataIsError: false,
        pageLoading: false
      };

    case actions.ADD_TEMPLATE_LEAD_DATA_FAILED:
      return {
        ...state,
        templateLeadDataLoading: action.loading,
        errorMessage: action.message,
        templateLeadDataIsError: true,
        pageLoading: false
      };

    case actions.EDITING_TEMPLATE_LEAD_DATA:
      return {
        ...state,
        templateLeadDataisError: false,
        templateLeadDataLoading: true,
        pageLoading: action.loading
      };

    case actions.EDIT_TEMPLATE_LEAD_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        templateLeadDataisError: false,
        templateLeadDataLoading: false,
        pageLoading: action.loading
      };

    case actions.EDIT_TEMPLATE_LEAD_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        templateLeadDataisError: true,
        templateLeadDataLoading: false,
        pageLoading: action.loading
      };

    case actions.FETCHING_MIS_DATA_BY_ID:
      return {
        ...state,
        activeMISData: null,
        pageLoading: action.loading
      };

    case actions.FETCH_MIS_DATA_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeMISData: action.result,
        isError: false
      };

    case actions.FETCH_MIS_DATA_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeMISData: null,
        isError: true
      };

    case actions.DOWNLOADING_LEAD_TEMPLATE_FILE:
      return {
        ...state,
        downloadLeadTemplateFileLoading: true,
        pageLoading: true
      };

    case actions.DOWNLOAD_LEAD_TEMPLATE_FILE_SUCCESS:
      return {
        ...state,
        downloadLeadTemplateFileLoading: false,
        pageLoading: false,
        downloadLeadTemplateFileIsError: false,
        errorMessage: action.message,
        isError: false
      };

    case actions.DOWNLOAD_LEAD_TEMPLATE_FILE_FAILED:
      return {
        ...state,
        downloadLeadTemplateFileLoading: false,
        pageLoading: false,
        downloadLeadTemplateFileIsError: true,
        errorMessage: action.message,
        isError: true
      };

    case authActions.LOGOUT:
      // reset all redux param values
      return initState;

    default:
      return state;
  }
}
